import { Spin } from 'antd';
import React from 'react';

export default function LoadingIndicator() {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
    >
      <Spin tip="Loading..." />
    </div>
  );
}
